import { render, staticRenderFns } from "./subjectInfo.vue?vue&type=template&id=71b32a4a&scoped=true&"
import script from "./subjectInfo.vue?vue&type=script&lang=js&"
export * from "./subjectInfo.vue?vue&type=script&lang=js&"
import style0 from "./subjectInfo.vue?vue&type=style&index=0&id=71b32a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b32a4a",
  null
  
)

export default component.exports